import { getAccessToken } from './auth';
import { getEmailFromToken } from './tokenClaims';
import { getUserEmail } from './sessionStore';

/** Email for the logged-in user — JWT first, then in-memory session. */
export function getClientEmail() {
  const fromToken = getEmailFromToken(getAccessToken());
  if (fromToken) return fromToken;
  return getUserEmail();
}
